// extracted by mini-css-extract-plugin
export default {"loadMoreContainer":"PrimeCommunityBoardsContainer_loadMoreContainer__Tc0IZ"};